
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 149.26 122.63"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CSRS_Clinical_Study_Report_copy_3","data-name":"CSRS (Clinical Study Report) copy 3"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M75.09 7.92l65.5 7.88.01-4.12-65.51-4.22v.46zM138.19 22.84l.01-4.34-59.44-7.16 59.43 11.5z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M77 1.79l-6.64 7.63v43.21H80V37l44.7 25.78L80 88.61V72.93h-9.68v35.73l72.25 14v-7.32l2.32.28v-7.12l2.4.15V99.3h1.94l.03-99.3zm65.49 21.59l-59.41-11.5L142.52 19zm2.4-7L79.41 8.46V8l65.51 4.22zm2-7L79.42 5v-.3L146.86 3z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M75.1 4.49l67.44 4.34V2.49L75.1 4.16v.33z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M117.5 62.78L83.57 43.19v13H59.83a33.5 33.5 0 01-11.09 13.1h34.83v13z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M58.89 35.94A29.75 29.75 0 1031.77 71.6l1.63 8a9 9 0 00-3.27 8.9l4.32 21.06a9 9 0 0017.64-3.62l-4.33-21.09A9 9 0 0041.24 78l-1.64-8a29.78 29.78 0 0019.29-34.06zm-48.48 10a19.75 19.75 0 1123.32 15.33A19.77 19.77 0 0110.41 45.9z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M29.64 59.43c.42 0 .82 0 1.23-.07a17.69 17.69 0 010-35.29c-.41 0-.81-.06-1.23-.06a17.71 17.71 0 000 35.42z"}})])])])
          )
        }
      }
    